// A boundary around a view that can fail on its own: instead of React
// unmounting the whole page (every button gone, nothing to read), the
// view shows what went wrong, offers a retry, and reports the error to
// the API journal (helpers/clientLog).
//
//   <ErrorBoundary name="Construction tracking · model"> ... </ErrorBoundary>
import React from "react";
import { Button } from "antd";
import { reportClientError } from "helpers/clientLog";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null, tries: 0 };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    reportClientError(`boundary:${this.props.name || "view"}`, error, { componentStack: info && info.componentStack });
  }

  render() {
    const { error, info, tries } = this.state;
    if (!error) return <React.Fragment key={tries}>{this.props.children}</React.Fragment>;
    const stack = String((error && error.stack) || "").split("\n").slice(0, 4).join("\n");
    const where = String((info && info.componentStack) || "").split("\n").filter(Boolean).slice(0, 4).join("\n");
    return (
      <div style={{ padding: 16, border: "1px solid #f5c2c7", background: "#fff5f5", borderRadius: 6, margin: 8 }}>
        <div style={{ fontWeight: 700, color: "#b42318", marginBottom: 4 }}>
          {this.props.name || "This view"} hit an error and stopped.
        </div>
        <div style={{ fontSize: 12.5, color: "#333", marginBottom: 8 }}>
          It has been reported. The rest of the page still works; you can try this view again or reload.
        </div>
        <pre style={{ fontSize: 11, whiteSpace: "pre-wrap", background: "#fff", border: "1px solid #eee", padding: 8, borderRadius: 4, maxHeight: 180, overflow: "auto", margin: "0 0 8px" }}>
          {String(error && error.message ? error.message : error)}
          {stack ? `\n${stack}` : ""}
          {where ? `\n${where}` : ""}
        </pre>
        <Button size="small" onClick={() => this.setState({ error: null, info: null, tries: tries + 1 })}>Try again</Button>
        <Button size="small" style={{ marginLeft: 8 }} onClick={() => window.location.reload()}>Reload the page</Button>
      </div>
    );
  }
}
